import React from 'react';
import classnames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { I18n } from '@fiverr-private/i18n-react';
import { FilterIcon } from '@fiverr-private/icons';
import { grey_1200 } from '@fiverr-private/sass/helpers';
import { Button } from '@fiverr-private/button';
import ListingsToggle from '../../ListingsToggle';
import { useBusinessListingsContext } from '../Context';
import FiltersDrawer from '../FiltersDrawer';
import { countActiveFilters } from '../FiltersUtils';
import styles from './index.module.scss';

const FiltersButton = ({ activeFiltersCount }) => {
    const { isTouch } = getContext();

    return (
        <>
            <Button
                className={classnames(styles.filtersButton, 'm-r-24')}
                intent="secondary"
                variant="outline"
                size="lg"
            >
                <FilterIcon color={grey_1200} />
                <I18n k={'search_perseus.filter.filter'} />
                {activeFiltersCount > 0 && ` (${activeFiltersCount})`}
            </Button>
            <div className={classnames(styles.filtersButtonMobile, 'm-r-8', { [styles.enlargedHitArea]: isTouch })}>
                <FilterIcon color={grey_1200} size={20} />
                {activeFiltersCount > 0 && (
                    <span className="co-text-darkest text-bold m-l-8">{`(${activeFiltersCount})`}</span>
                )}
            </div>
        </>
    );
};

export const SidebarTopSection = () => {
    const { isExpertListings, activeFilters } = useBusinessListingsContext();

    const activeFiltersCount = countActiveFilters(activeFilters);

    return (
        <div className={classnames(styles.mainHeaderContent, 'flex flex-items-center')}>
            <FiltersDrawer>
                <FiltersButton activeFiltersCount={activeFiltersCount} />
            </FiltersDrawer>
            <div className={styles.toggle}>
                <ListingsToggle isExpertListings={isExpertListings} />
            </div>
        </div>
    );
};
